/*global drupalSettings*/
/*global Drupal*/
import React, { Component } from 'react';
import {apiEndpoint, searchUri, placeholder} from './helpers';
import ReactLoading from 'react-loading';

class App extends Component {
  constructor(props) {
      super(props);
      this.state = {
          query : '',
          result: [],
          loading: false,
          resultStyle: {},
          timeOut: false
      };
  }

  handleChange = (e) => {
      this.setState({query: e.target.value, result: []}, this.queryEndpoint);
  };

  queryEndpoint = () => {
      // todo: timeout toevoegen op input
      if(this.state.query.length >= 3){
          const url = apiEndpoint + this.state.query + "?_format=json";
          this.setState({loading: true});

          return fetch(url, {
              method: 'GET',
              credentials: 'include',

          })
          .then((response) => {
              return response.json();
          }).then((result)=> {
              this.setState({result,loading: false});
          }).catch(() => {

          });
  }
  };

  renderResult = () => {
      if(this.state.loading) {
          return (
              <div className="search-loader">
                  <ReactLoading type="spin" color={drupalSettings.cc_autocomplete_search.color} height={50} width={50} />
                  <span className="sr-only">Loading...</span>
              </div>
          )

      }
      if(this.state.result.length > 0){
          return this.state.result.map((node)=>{
              const title = node.title ? node.title + " - " + node.performer : node.performer;
              return (
                  <div key={node.id} className="result-row" onClick={() => window.location = node.path}>
                      <h3>{title.replace('&amp;', '&')}</h3>
                      <div className="search-excerpt-row" dangerouslySetInnerHTML={{ __html: node.excerpt }}>
                      </div>
                  </div>
              )
          })
      }
      if(this.state.query.length > 0){
          return (
              <div className="no-results">
                  {Drupal.t("No results found.")}
              </div>
          )
      }
  };

  mouseOut = () => {
      let timeOut = setTimeout(() => this.setState({'resultStyle': {"display": "none"}}), 500);
      this.setState({timeOut});
  };
  mouseOver = () => {
      if(this.state.timeOut){
          clearTimeout(this.state.timeOut);
          this.setState({timeOut : false});

      }
      this.setState({'resultStyle': {"display": "block"}});
  };

  render() {
    return (
        <form className="search-app" action={searchUri} method="GET"
              onMouseOut={() => this.mouseOut()}
              onMouseOver={() => this.mouseOver()}>
            <div className="autocomplete-ctn">
                <div className="input-group">

                    <input type="text" className="form-control input-bordered" id="cc-autocomplete-input" placeholder={placeholder} aria-label={placeholder} name="search_api_fulltext" autocomplete="off" value={this.state.query} onChange={this.handleChange} />
                    <span className ="input-group-btn">
                         <button className="btn btn-primary" type="submit">Zoeken <i className="fa fa-search" aria-hidden="true"></i></button>
                    </span>
                </div>
                <div className="search-results" style={this.state.resultStyle}>
                    {this.renderResult()}
                </div>
            </div>
        </form>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js